import { render, staticRenderFns } from "./toubiao.vue?vue&type=template&id=353711a8&"
import script from "./toubiao.vue?vue&type=script&lang=js&"
export * from "./toubiao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports